import React from "react";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import NanoFlex from "../Global/NanoFlex.js";
import playlistService from "../../services/PlaylistService.js";

import Button from "../Nano/Buttons/Button.js";
import Spinner from "../Nano/Spinner.js";
import Type from "../Global/Typography.js";
import Input from "../Nano/Input.js";

import { ReactComponent as Playlist } from "../Global/Icons/playlist.svg";
import BaseComponent from "../BaseComponent";

const multiple = nota.global.multiple;

const CreatePlaylistModalStyle = styled.div`
  width: 350px;
  background-color: ${nota.color.neutral.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  padding: ${multiple * 3 + "px"};
  .headerModal {
    padding-bottom: ${multiple + "px"};
    border-bottom: 0.5px solid ${nota.color.neutral.NeuFour};
    svg {
      height: 16px;
      width: 16px;
      path {
        fill: ${nota.color.main.default};
      }
    }
    h3 {
      margin-left: ${multiple + "px"};
      text-transform: uppercase;
      b {
        color: ${nota.color.main.default};
      }
    }
  }
  .modalContainer {
    .modalWrapper {
      padding: ${multiple * 3 + "px"} 0;
    }
  }

  .loadingContainer {
    min-height: 344px;
  }
  .formWrapper {
    margin-bottom: ${multiple + "px"};
    .formContainer {
      margin-bottom: ${multiple + "px"};
    }
    p {
      margin-bottom: 2px;
    }
    .dropDownContainer {
      width: 100%;
    }
    .inputWrapper {
      width: 100%;
      div {
        margin: 0;
      }
    }
    textarea {
      font-family: ${nota.font};
      width: 100%;
      height: 150px;
      overflow: auto;
      border: 1px solid ${(props) => (props.error ? nota.color.main.mTwo : nota.color.neutral.NeuTwo)};
      padding: 10px;
      width: 100%;
      font-size: 12px;
      color: ${nota.color.neutral.NeuOne};
      resize: none;
      &::placeholder {
        color: ${nota.color.neutral.NeuTwo};
      }
    }
  }

  .btnsContainer {
    padding: 16px 8px 0 8px;
    border-top: 0.5px solid ${nota.color.neutral.NeuFour};
    .cta {
      margin: 0;
    }
  }

  .dropDownWrapper {
    .dropdown-content {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
    }
  }

  /* MEDIA QUERIES */
  @media only screen and (max-width: 520px) {
    width: 90vw;
    .modalContainer {
      .btnsContainer {
        flex-direction: column;
        height: auto;
        .buttonWrapper {
          order: 1;
        }
        .simpleButtonWrapper {
          order: 2;
          margin-top: 8px;
        }
      }
    }
  }

  @media only screen and (max-width: 320px) {
    .headerModal {
      h3 {
        font-size: 16px;
      }
    }
  }
`;

class CreatePlaylistModal extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = this.getDefaultState();
  }

  getDefaultState = () => {
    return {
      name: "",
      nameError: false,
      description: "",
    };
  };

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  onNameChange = (value) => {
    this.setState({ name: value });
  };

  onDescriptionChange = (value) => {
    this.setState({ description: value });
  };

  addNewPlaylist = () => {
    if (this.state.name && this.state.name.trim() != "") {
      this.setState({ nameError: false });
      playlistService
        .addPlaylist({
          Name: this.state.name,
          Description: this.state.description,
        })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            // Catch
            if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
          }
        })
        .then((data) => {
          /*Trigger playlistsChange Event */
          window.dispatchEvent(new Event("playlistsChange"));
          if (this.props.filter) {
            this.addProgramsToPlaylist(data);
          } else {
            this.setState({ name: "", description: "" }, () => {
              if (this.props.nextAction) {
                this.props.nextAction(data);
              }
            });
          }
        });
    } else {
      this.setState({ nameError: true });
    }
  };

  cancelAddToPlaylist = () => {
    this.setState(this.getDefaultState(), () => {
      this.props.cancelAction();
    });
  };

  addProgramsToPlaylist = (playlist) => {
    this.setState({ loading: true }, () => {
      playlistService
        .addProgramsToPlaylist({
          IdPlaylists: [playlist.id],
          Filter: this.props.filter,
          Mode: this.props.mode,
        })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            // Catch
            if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
          }
        })
        .then((data) => {
          window.dispatchEvent(new Event("playlistsChange"));
          this.setState({ name: "", description: "", loading: false }, () => {
            if (this.props.nextAction) {
              this.props.nextAction(playlist);
            }
          });
        });
    });
  };

  render() {
    return (
      <CreatePlaylistModalStyle>
        <NanoFlex className="headerModal" justifyContent="flex-start">
          <Playlist />
          <Type.h3>
            <b>{this.translation.playlists.createNewPlaylist}</b>
          </Type.h3>
        </NanoFlex>
        {this.state.loading && (
          <NanoFlex className="loadingContainer">
            <Spinner />
          </NanoFlex>
        )}
        {!this.state.loading && (
          <NanoFlex className="modalContainer" flexDirection={"column"} justifyContent="space-between" alignContent="space-between">
            <NanoFlex className="modalWrapper" flexDirection={"column"}>
              <NanoFlex className="formWrapper" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                <NanoFlex className="formContainer" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                  <Type.p>{this.translation.playlists.name}</Type.p>
                  <div className="inputWrapper">
                    <Input defaultValue={this.state.name} title="" placeholder={this.translation.playlists.namePlaceholder} error={this.state.nameError} onChangeAction={this.onNameChange} />
                  </div>
                </NanoFlex>

                <NanoFlex className="formContainer" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                  <Type.p>{this.translation.playlists.description}</Type.p>
                  <textarea
                    value={this.state.description}
                    placeholder={this.translation.playlists.descriptionPlaceholder}
                    onChange={(e) => {
                      this.onDescriptionChange(e.target.value);
                    }}></textarea>
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>

            <NanoFlex className="btnsContainer" alignContent={"flex-end"}>
              <Button label={this.translation.geral.cancel} simple clickAction={this.cancelAddToPlaylist} />
              <Button label={this.translation.geral.confirm} clickAction={this.addNewPlaylist} />
            </NanoFlex>
          </NanoFlex>
        )}
      </CreatePlaylistModalStyle>
    );
  }
}

// Set default props
CreatePlaylistModal.defaultProps = {
  cancelAction: () => null,
  nextAction: () => null,
};

export default CreatePlaylistModal;

/*
Doc
import CreatePlaylistModal from '../../Micro/CreatePlaylistModal.js';

<CreatPlaylistModal
    cancelAction={() => console.log('cancelAction')}
    nextAction={() => console.log('nextAction')}
/>
*/
